import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from '@nvision/identity-core';

import { queryClient } from '@/services/query-client';

import '@ant-design/v5-patch-for-react-19';

import store from '@/redux/store';
import RootRoutes from '@/views/routes/RootRoutes';

import './styles/themes/variables.scss';
import './styles/App.scss';

import { useTheme } from '@/hooks/use-theme';
import { authService } from '@/modules/auth';

import { useFixPDFDevMode } from './hooks';

import '@/modules/features-toggle';
import '@/utils/file/setup-pdf';

import { DialogsProvider } from '@nvision/ui';

import { ENV_VARS } from './env';
import { guardAppVersion } from './services/version-guard';

guardAppVersion(ENV_VARS.VERSION);

function App() {
  if (process.env.NODE_ENV === 'development') {
    // biome-ignore lint/correctness/useHookAtTopLevel: <suppress>
    useFixPDFDevMode();
  }
  useTheme();

  return (
    <div className="App">
      <AuthProvider auth={authService}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <NuqsAdapter>
              <Router>
                <RootRoutes />
              </Router>
            </NuqsAdapter>
          </QueryClientProvider>
        </Provider>
      </AuthProvider>
      <DialogsProvider />
    </div>
  );
}

export default App;
